import { render } from "./EmpresaIndex.vue?vue&type=template&id=f6412c44&scoped=true&ts=true"
import script from "./EmpresaIndex.vue?vue&type=script&lang=ts"
export * from "./EmpresaIndex.vue?vue&type=script&lang=ts"

import "./EmpresaIndex.vue?vue&type=style&index=0&id=f6412c44&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6412c44"]])

export default __exports__